<template>
  <div>
    <back>轮播</back>
    <bar bgcolor="blue">这不是轮播</bar>
    <check-box />
  </div>
</template>
<script>
import checkBox from 'packages/checkbox/checkbox'

export default {
  name: 'Swiper',
  components: {
    checkBox
  }
}
</script>
